<template>
  <div class="item" :class="[sportsClassItem.class, item.status == 3 ? 'close' : '']">
    <div class="time">{{ item.matchdate }}</div>
    <!--<div class="event">{{ sportsClassItem.text }} - {{ item.lnm }}</div>-->
    <div class="event">{{ item.lnm }}</div>
    <div class="type" :class="[{pre_match:item.game_type === 'pre'}, {live:item.game_type === 'live'}]">
      {{ statusItem }}
    </div>
    <div class="team_area">
      <span class="team left">{{ item.hTeamNm }}</span>
      <span class="vs">{{ item.game_type === 'live' ? item.Score : 'vs' }}</span>
      <span class="team right">{{ item.aTeamNm }}</span>
    </div>
    <component v-bind:is="selectedComponent" :detail="item"></component>
    <div class="info" v-if="!type">
      <dl>
        <dt>대결 타입</dt>
        <dd>{{ item.mnm }}</dd>
      </dl>
      <dl>
        <dt>방장 선택</dt>
        <dd>{{ ownerPick() }} {{ '('+item.dPoint+')' }}</dd>
      </dl>
    </div>
    <div class="info" v-else>
      <dl>
        <dt>설정 골드</dt>
        <dd>{{ numberToString(item.gold) }}</dd>
      </dl>
      <dl>
        <dt>승리시 총 획득 골드</dt>
        <dd class="win">{{ numberToString(winPrice) }}</dd>
      </dl>
      <dl>
        <dt>패배시 총 차감 골드</dt>
        <dd class="lose">{{ numberToString(lossPrice) }}</dd>
      </dl>
      <dl v-if="type">
        <dt>대결 타입</dt>
        <dd>{{ item.mnm }}</dd>
      </dl>
      <dl>
        <dt>대결 결과</dt>
        <dd :class="item.result">{{ gameResult[item.result] }}</dd>
      </dl>
    </div>
    <div class="btn_area">
      <template v-if="item.isOwner === true">
        <a class="_btn" href="javascript:;" v-if="item.status === 1" @click="cancelMatch">게임취소</a>
        <a class="_btn" href="javascript:;" v-if="item.status === 2" @click="cancelMatch">게임취소</a>
        <a class="_btn" href="javascript:;" v-if="item.status === 2" @click="giveUp">배틀포기</a>
        <a class="_btn" href="javascript:;" v-if="item.status === 3" @click="deleteMatch">게임삭제</a>
      </template>
      <template v-else>
        <a class="_btn" href="javascript:;" v-if="item.status === 1" @click="openDetail">입장하기</a>
        <a class="_btn" href="javascript:;" v-if="item.status === 2" @click="giveUp">배틀포기</a>
        <a class="_btn" href="javascript:;" v-if="item.status === 3" @click="retry">재도전</a>
        <a class="_btn" href="javascript:;" v-if="item.status === 3" @click="deleteMatch">게임삭제</a>
      </template>
    </div>
  </div>

</template>

<script>
  import matchDetailItem from '@/components/match/match-detail-item'
  import matchDetailItemMy from '@/components/match/match-detail-item-my'

  export default {
    name: "match-list-item",
    components: {
      matchDetailItem,
      matchDetailItemMy
    },
    props: [
      'item',
      'type'
    ],
    created() {
      
    },
    methods: {
      ownerPick() {
        const index = this._.findIndex(this.item.outcomeList, {'outcomeid': this.item.owner_outcome_id});
        return window.lang[this.item.outcomeList[index].kind]
      },
      openDetail() {
        if (this.item.isMine) {
          alert('자신의 경기는 참여 하실수 없습니다.');
          return;
        }
        this.$store.dispatch('match/openDetail', this.item);
      },
      async deleteMatch() {
        if (confirm('삭제 하시겠습니까?') === false) {
          return false;
        }

        let res = await this._post("/v1/match/delete", {
          gameId: this.item.id
        });

        if (res.data.message) {
          alert(res.data.message);
          this.$eventBus.$emit("matchList");
          conm.topuserinfo()
        }
      },
      async giveUp() {
        if (confirm('경기를 포기 하시겠습니까?') === false) {
          return false;
        }

        let res = await this._post("/v1/match/giveUp", {
          gameId: this.item.id
        });

        if (res.data.message) {
          alert(res.data.message);
          this.$eventBus.$emit("matchList");
          conm.topuserinfo()
        }
      },
      async cancelMatch() {
        if (confirm('게임 취소 하시겠습니까?') === false) {
          return false;
        }

        let res = await this._delete("/v1/match", {
          gameId: this.item.id
        });

        if (res.data.message) {
          alert(res.data.message);
          this.$eventBus.$emit("matchList");
          conm.topuserinfo()
        }

      },

      retry() {
        this.$store.dispatch('match/openRetry', this.item.id);
      },
    },
    computed: {
      statusItem() {
        return this.statusList[this.item.game_type]
      },
      sportsClassItem() {
        const index = this._.findIndex(this.sportsCategory, {'id': this.item.sportsid});
        return this.sportsCategory[index]
      },
      winPrice() {
        let price = this.item.owner_price;
        if (!this.item.isOwner) {
          price = this.item.guest_price;
        }
        return Math.round(this.item.gold * price);
      },
      lossPrice() {
        let price = this.item.guest_price;
        if (!this.item.isOwner) {
          price = this.item.owner_price;
        }
        return Math.round((this.item.gold * price) * -1)
      },
      selectedComponent() {
        return this.type ? 'matchDetailItemMy' : 'matchDetailItem'
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/match/match-list-item.vue